import React, { useState } from "react";
import { Link, NavLink } from "react-router-dom";
import { useNavigate } from "react-router-dom";
export let data_student;

// import ViewEvaluation from "../../evaluation/ViewEvaluation";

const CompleteSTableHW = (props) => {
  const navigate = useNavigate();
  const deadline = new Date(props?.deadline);
  const submitted = props?.submitted_on;
  console.log(props, "props");
  data_student = props;
  const [click, setClick] = useState(false);
  console.log(props);
  let url = `/Completedallquestions`;
  const handleGetStudentHomework = () => {
    const searchParams = new URLSearchParams();
    searchParams.set("Name", props.Name);
    //correct state obj for avoid name confliction
    navigate(url + "?" + searchParams.toString(), {
      state: {
        homework_id: props.Homework_id,
        student_id: props.Student_id,
        Status: props?.Status,
      },
    });
    setClick(true);
  };

  const handleStatus = (text) => {
    if (deadline < submitted) {
      return "(Delayed)";
    }
  };

  return (
    <>
      <tr style={{ borderBottom: "1px solid #D9D9D9" }}>
        <td
          onClick={
            props.Status === "completed" ? handleGetStudentHomework : null
          }
          style={{ textAlign: "center" }}
        >
          {props.Status === "completed" ? (
            <NavLink
              state={{
                homework_id: props.Homework_id,
                student_id: props.Student_id,
                Status: props?.Status,
              }}
              to={`${url}`}
              className="link"
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                gap: "8px",
                textDecoration: "none",
              }}
            >
              <img
                src={
                  props?.profile_pic
                    ? props?.profile_pic
                    : props?.gender === "M"
                    ? props?.avatar_profile
                      ? "/images/Boys/" + props?.avatar_profile + ".webp"
                      : "/images/Student_boy_pic.png"
                    : props?.gender === "F"
                    ? props?.avatar_profile
                      ? "/images/Girls/" + props?.avatar_profile + ".webp"
                      : "/images/Student_girl_pic.png"
                    : "/images/default image.png"
                }
                alt="icon"
                style={{
                  width: "20px",
                  height: "20px",
                  margin: "0px 10px",
                  borderRadius: "50%",
                }}
                onError={(e) => {
                  if (props?.gender === "M") {
                    e.target.src = props?.avatar_profile
                      ? "/images/Boys/" + props?.avatar_profile + ".webp"
                      : "/images/Student_boy_pic.png";
                  } else if (props?.gender === "F") {
                    e.target.src = props?.avatar_profile
                      ? "/images/Girls/" + props?.avatar_profile + ".webp"
                      : "/images/Student_girl_pic.png";
                  } else {
                    e.target.src = "/images/default image.png";
                  }
                }}
              />
              <span
                style={{
                  display: "inline-block",
                  width: "120px", // Fixed width
                  whiteSpace: "nowrap",
                  overflow: "hidden",
                  textOverflow: "ellipsis",
                  textAlign: "left",
                }}
              >
                {props.Name}
              </span>
            </NavLink>
          ) : (
            <span
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                gap: "8px",
              }}
            >
              <img
                src={
                  props?.profile_pic
                    ? props?.profile_pic
                    : props?.gender === "M"
                    ? props?.avatar_profile
                      ? "/images/Boys/" + props?.avatar_profile + ".webp"
                      : "/images/Student_boy_pic.png"
                    : props?.gender === "F"
                    ? props?.avatar_profile
                      ? "/images/Girls/" + props?.avatar_profile + ".webp"
                      : "/images/Student_girl_pic.png"
                    : "/images/default image.png"
                }
                alt="icon"
                style={{
                  width: "20px",
                  height: "20px",
                  margin: "0px 10px",
                  borderRadius: "50%",
                }}
                onError={(e) => {
                  if (props?.gender === "M") {
                    e.target.src = props?.avatar_profile
                      ? "/images/Boys/" + props?.avatar_profile + ".webp"
                      : "/images/Student_boy_pic.png";
                  } else if (props?.gender === "F") {
                    e.target.src = props?.avatar_profile
                      ? "/images/Girls/" + props?.avatar_profile + ".webp"
                      : "/images/Student_girl_pic.png";
                  } else {
                    e.target.src = "/images/default image.png";
                  }
                }}
              />
              <span
                style={{
                  display: "inline-block",
                  width: "120px",
                  whiteSpace: "nowrap",
                  overflow: "hidden",
                  textOverflow: "ellipsis",
                  textAlign: "left",
                }}
              >
                {props.Name}
              </span>
            </span>
          )}
        </td>

        <td>{props.School_Email}</td>
        <td>{props.Class}</td>
        <td>{props.Division}</td>
        <td>{props.Submited_Date || "Not Submitted"}</td>
        <td>
          {props.Student_Marks === "0"
            ? "--"
            : `${props.Student_Marks}/${props.total_marks}`}
        </td>
        <td>
          {props.Status} {handleStatus(props.Status)}
        </td>
      </tr>

      {click &&
        {
          /*   <div className=" transprant_body_finalResult">
        <img
          onClick={() => setClick(false)}
          className="evaluation_close_btn"
          src="/images/cross-circle3.svg"
        />
        <ViewEvaluation />
      </div> */
        }}
    </>
  );
};

export default CompleteSTableHW;
